import { Component, Input, OnInit } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';

@Component({
  selector: 'sous-labels',
  templateUrl: './labels.component.html',
  styleUrls: ['./labels.component.scss'],
})

export class LabelsComponent extends FieldType<FieldTypeConfig> implements OnInit {
  @Input() override field: any;
  label: any;


  ngOnInit() {
    this.label = this.field.templateOptions.label;
  }
}
